import type { ClaimReasonResponse } from './api';

export interface ClaimReasonOption {
  label: string;
  value: string;
}

export const normalizeClaimReasonList = (list: ClaimReasonResponse): ClaimReasonOption[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.reasonCodeDesc,
    value: row.reasonCode,
  }));
};
